
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinparbani() {



const cardData = {
  keyword: 'Cab Service in Parbhani MIDC',
  heading: 'eTravo: Cab Service in Parbhani MIDC',
  headingDescription: `eTravo offers dependable and professional cab services in Parbhani MIDC, tailored to support the daily travel requirements of industrial workers, corporate staff, and visiting clients. Strategically designed for the evolving transportation needs of Parbhani’s industrial zone, our services combine comfort, safety, and punctuality. eTravo’s fleet includes air-conditioned, GPS-enabled vehicles driven by experienced chauffeurs who follow strict corporate etiquette. Whether it's daily employee pickup and drop, business travel, or VIP client transfers, we provide flexible rental options and real-time tracking to ensure a hassle-free experience. With eTravo, businesses in Parbhani MIDC benefit from reliable, round-the-clock transport that enhances productivity and operational efficiency`,

  top: 'Top Places to visit in Parbhani with eTravo',
  "topPlaces": [
    {
      "title": "Parbhani MIDC Industrial Area",
      "description": "Parbhani's MIDC zone hosts a variety of industries, including agro-processing, textiles, and manufacturing units. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Parbhani City Center",
      "description": "The commercial and administrative heart of Parbhani, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Parbhani Junction Railway Station",
      "description": "A crucial railway hub connecting Parbhani with major cities across India. eTravo provides convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Parbhani Logistics Hub",
      "description": "An emerging logistics center enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Shri Shivaji College, Parbhani",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Parbhani",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Parbhani Retail and Shopping Centers",
      "description": "Facilitating transportation for employees and customers to and from major retail outlets and shopping centers in Parbhani. eTravo's services enhance the shopping experience by providing convenient and safe travel options."
    },
    {
      "title": "Parbhani Hospitality Sector",
      "description": "Providing transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry. eTravo's services contribute to guest satisfaction and operational efficiency."
    },
    {
      "title": "Parbhani Educational Institutions",
      "description": "Supporting various schools and colleges in Parbhani by offering transportation solutions for students and faculty members. eTravo ensures safe and timely commutes, fostering a conducive learning environment."
    },
    {
      "title": "Parbhani Healthcare Facilities",
      "description": "Offering reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics. eTravo's services are integral to the region's healthcare accessibility."
    }
  ],

 services: [
  {
    name: 'Parbhani MIDC Corporate Cab Rentals',
    description: `Specialized corporate cab rental solutions for businesses in Parbhani MIDC, offering both short-term and long-term plans suited for daily operations, business travel, and event logistics. Our services are ideal for companies needing scalable transportation backed by a well-maintained fleet, professional drivers, and round-the-clock customer support to ensure timely and smooth operations.`
  },
  {
    name: 'Employee Transport Cab Parbhani MIDC',
    description: `Daily transport solutions tailored to factory and office shift schedules, providing safe and punctual commutes for employees. GPS tracking, route optimization, and real-time monitoring ensure efficiency and peace of mind. Our commitment to safety and comfort makes us a reliable partner in maintaining employee satisfaction and operational consistency.`
  },
  {
    name: 'Business Cab Services Parbhani MIDC',
    description: `On-demand cab services crafted for business executives, managers, and field staff. Whether it's client visits, inter-office travel, or urgent site inspections, our trained drivers, clean vehicles, and punctuality help businesses stay agile and efficient in their daily functions.`
  },
  {
    name: 'Corporate Staff Cabs Parbhani MIDC',
    description: `Multi-route staff cab solutions for transporting employees in groups while reducing costs and increasing route efficiency. Our service includes real-time trip tracking, dedicated support coordination, and strict adherence to safety protocols, making us a trusted mobility partner for growing enterprises.`
  },
  {
    name: 'Reliable Corporate Cab Service Parbhani MIDC',
    description: `Our hallmark service focused on reliability and consistency, providing clean, sanitized vehicles, uniformed professional drivers, and on-time pickups. Designed for companies that demand professionalism in daily employee and executive transport, backed by service-level agreements and transparent communication.`
  },
  {
    name: 'AC Corporate Cabs Parbhani MIDC',
    description: `Fully air-conditioned cabs offering comfort for corporate travel during Parbhani’s varying weather conditions. Whether transporting staff across industrial zones or executives to meetings, our AC cabs ensure a stress-free, cool ride, essential for employee well-being and executive readiness.`
  },
  {
    name: 'Staff Pickup and Drop Cab Parbhani MIDC',
    description: `Flexible cab services supporting multiple employee shifts, including early morning and late-night drops. Designed for manufacturing units and offices with 24/7 operations, our service ensures workforce punctuality, security during odd hours, and complete support for scheduling and adjustments.`
  },
  {
    name: 'Affordable Business Cab Rentals Parbhani MIDC',
    description: `Cost-optimized cab rental plans for small businesses and medium enterprises in Parbhani MIDC. With flexible contracts, transparent billing, and the ability to scale up or down as per business needs, we help organizations manage their transportation expenses without compromising on quality.`
  },
  {
    name: 'Executive Cab Services Parbhani MIDC',
    description: `Luxury cab services for senior executives, visiting clients, and business leaders. Our fleet of high-end vehicles is operated by professionally trained chauffeurs, ensuring a premium experience ideal for airport transfers, board meetings, and high-profile site visits.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Parbhani MIDC',
    description: `Fixed-route monthly packages designed to simplify logistics, stabilize costs, and improve service consistency. Ideal for HR and admin teams managing transportation across departments, these plans come with end-to-end coordination, centralized billing, and performance tracking tools.`
  },
  {
    name: 'Industrial Area Employee Transport Parbhani MIDC',
    description: `Customized staff transport solutions for factories and warehouses located in and around Parbhani MIDC. Routes are optimized for efficiency and employee convenience, ensuring smooth transitions across shifts and compliance with industrial transport regulations.`
  },
  {
    name: 'Corporate Client Cabs Parbhani MIDC',
    description: `Dedicated transport services for corporate guests, ensuring a positive brand experience. From well-groomed drivers to well-maintained vehicles, we handle all transfers—be it airport pickups, hotel drops, or facility tours—with professionalism and discretion.`
  },
  {
    name: 'Business Meeting Cabs Parbhani MIDC',
    description: `Fast-response cab service for time-sensitive business meetings within Parbhani and nearby cities. We ensure executives reach their meetings promptly with quick dispatch, experienced drivers, and GPS-enabled vehicles that navigate traffic with precision.`
  },
  {
    name: 'Parbhani Industrial Area Cab Hire',
    description: `Flexible cab hire service across Parbhani’s industrial areas for logistics teams, field executives, and administrative errands. With drivers familiar with local roads, industrial zones, and site access requirements, we ensure fast and seamless travel.`
  },
  {
    name: 'Corporate Shuttle Cabs Parbhani MIDC',
    description: `Large-capacity transport solutions using vans and minibuses, ideal for moving batches of employees during shift changes or corporate events. Shuttle services are optimized to reduce per-head costs and environmental impact while enhancing team coordination and punctuality.`
  }
],

tableData: [
  ['Parbhani MIDC Corporate Cab Rentals', 'Employee Transport Cab Parbhani MIDC'],
  ['Business Cab Services Parbhani MIDC', 'Corporate Staff Cabs Parbhani MIDC'],
  ['Reliable Corporate Cab Service Parbhani MIDC', 'AC Corporate Cabs Parbhani MIDC'],
  ['Staff Pickup and Drop Cab Parbhani MIDC', 'Affordable Business Cab Rentals Parbhani MIDC'],
  ['Executive Cab Services Parbhani MIDC', 'Monthly Corporate Cab Rentals Parbhani MIDC'],
  ['Industrial Area Employee Transport Parbhani MIDC', 'Corporate Client Cabs Parbhani MIDC'],
  ['Business Meeting Cabs Parbhani MIDC', 'Parbhani Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Parbhani MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Parbhani MIDC",
    "WhyChoosedescription": "eTravo offers reliable and customized cab services specifically designed for businesses operating in Parbhani MIDC. As the industrial area continues to grow, our transport solutions ensure timely employee commutes, reduce delays, and contribute to improved operational efficiency."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet features a wide selection of well-maintained vehicles, including sedans, SUVs, and multi-utility cabs. Whether you need daily employee transportation, executive travel, or guest mobility, we have the right vehicle for every corporate requirement."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are thoroughly trained and well-versed with Parbhani MIDC’s layout and road conditions. Their local expertise ensures smooth navigation, on-time arrivals, and professional service throughout the journey."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "Understanding the dynamic shift patterns in industrial operations, we offer flexible booking options such as pre-scheduled rides, on-demand bookings, and long-term contracts—helping businesses manage transportation seamlessly."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All our cabs are equipped with GPS tracking, providing real-time monitoring and route visibility. This promotes passenger safety, increases accountability, and ensures employers have full transparency over employee travel."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We ensure full billing transparency by providing detailed invoices that break down trip fares and mileage. This simplifies financial tracking and makes it easy for corporate clients to manage transportation expenses."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet is sanitized regularly, and drivers follow strict hygiene and safety protocols. We are committed to maintaining a clean, safe, and health-conscious travel environment for all passengers."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Every corporate client receives dedicated account management to handle scheduling, special requests, and ongoing support. Our team ensures a smooth, reliable cab service tailored to your operational needs in Parbhani MIDC."
  }
]



}

const faqData = [
  [
    {
      question: "Which areas do your Parbhani MIDC cab services cover?",
      answer: "Our cab services operate throughout the Parbhani MIDC region and nearby industrial zones to ensure smooth employee transportation."
    },
    {
      question: "Do you support scheduled pickups for different shift timings?",
      answer: "Yes, we offer fully customizable shift-based cab scheduling to match your workforce's operational hours."
    },
    {
      question: "Can we receive a monthly bill with trip summaries?",
      answer: "Absolutely. We provide monthly consolidated invoices along with detailed trip logs to support easy expense management."
    },
    {
      question: "Are drivers trained for industrial area commuting?",
      answer: "Yes, our drivers are trained in safe driving practices, professional etiquette, and are familiar with Parbhani MIDC routes."
    },
    {
      question: "What safety protocols do you follow during cab operations?",
      answer: "We use GPS-enabled tracking, regular vehicle checks, sanitized cabins, and emergency support systems for passenger safety."
    },
    {
      question: "Do businesses get dedicated support from your team?",
      answer: "Yes, corporate clients benefit from dedicated account managers and priority support for any transportation-related queries."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Rajesh Pawar",
    designation: "Facilities Manager, Parbhani AgroTech",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s timely cab services have made employee movement more reliable and stress-free at our Parbhani unit.”"
  },
  {
    name: "Ms. Shraddha Joshi",
    designation: "HR Coordinator, Parbhani Food Processing Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“We’ve been impressed by the professionalism and responsiveness of eTravo’s support team. The cab service quality is excellent.”"
  }
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Parbhani MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-parbhani-midc.jpg",
  "description": "Reliable corporate cab service in Parbhani MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-parbhani-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Parbhani MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Parbhani MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/83.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinparbani;